import React, { useState, useEffect } from "react";
import { useCurrentRoute, useNavigation, Link } from "react-navi";
import { useSelector, useDispatch } from "react-redux";
import {
  Input,
  Col,
  Button,
  Row,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup
} from "reactstrap";
import { updateField, resetConfig } from "../../redux/actions/configActions";
import Paginator from "../components/Paginator";
import TemplateView from "./templateView";
import GeneralSettings from "../Configuration/config-form-sections/GeneralSettings";
import SharingSettings from "../Configuration/config-form-sections/SharingSettings";
import { templateSubmissionAttributes } from "../../constants/templateAttributes";
import configService from "../../services/api/configService";
import Container from "../components/Container";
import CardsDisplay from "../components/CardsDisplay";
import TemplateSearch from "./templateSearch";

function TemplateSelector() {
  const [templates, setTemplates] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [searchParameters, setSearchParameters] = useState(null);
  const route = useCurrentRoute();
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const config = useSelector(state => state.configReducer.config);

  async function toggle() {
    setModal(!modal);
  }
  async function handleSubmit(event) {
    event.preventDefault();

    const data = new FormData();
    data.append("machineId", route.data.machineId);

    templateSubmissionAttributes.forEach(attribute => {
      if (config[attribute]) {
        data.append(attribute, config[attribute]);
      }
    });
    const response = await configService.createTemplateConfig(
      data,
      selectedTemplate
    );
    if (response) {
      navigation.navigate(`/machines/${route.data.machineId}/configs`, {
        body: { uploadSuccessful: true }
      });
    }
  }
  function handleSearch(searchParameters) {
    setSearchParameters(searchParameters);
  }

  function selectTemplate(event) {
    setModal(true);

    setSelectedTemplate(event.target.value);
  }

  useEffect(() => {
    dispatch(
      updateField({
        machineId: route.data.machineId
      })
    );
    return () => {
      dispatch(resetConfig());
    };
  }, [route.data.machineId]);

  useEffect(() => {
    setTemplates(route.data.templates.data);
  }, [route.data.templates.data, route.data.templates.page]);

  const templateCards = templates.map(template => {
    const actions = (
      <React.Fragment>
        <Col>
          <Button
            outline
            className=" btn-black btn-block btn btn-outline-dark"
            value={template._id}
            onClick={selectTemplate}
          >
            Use
          </Button>
        </Col>
      </React.Fragment>
    );
    return <TemplateView actions={actions} template={template} />;
  });

  return (
    <React.Fragment>
      <Container title="Configuration templates">
        <Link
          href="/templates/create"
          className="btn btn-black btn-block btn-outline-dark"
        >
          Create template
        </Link>
        <hr className="hr-black" />
        <CardsDisplay
          endpoint={`machines/${route.data.machineId}/configs/create?new=false`}
          pages={route.data.templates}
          cards={templateCards}
          searchParams={searchParameters}
        />
      </Container>
      <Modal className="modal-lg" isOpen={modal} toggle={toggle}>
        <ModalHeader>Please fill in the form below</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <GeneralSettings nomode />
            <SharingSettings />
            <FormGroup
              check
              row
              className=" mb-3 d-flex justify-content-center"
            >
              <Col>
                <Button
                  outline
                  className=" btn-block btn-black btn btn-outline-dark"
                  type="submit"
                >
                  Submit
                </Button>
              </Col>
              <Col>
                <Button
                  className="btn-red"
                  block
                  outline
                  color="danger"
                  onClick={toggle}
                >
                  Cancel
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}

export default TemplateSelector;



// WEBPACK FOOTER //
// ./src/views/template/TemplateSelector.jsx